@if (!isLandingPage) {
    <ds-header
            [navBarRef]="navBar"
            [appName]="title"
            [userInfo]="userInfoHeader"
            (requestLogout)="logoutFromApp()"
    ></ds-header>
}

<div class="d-flex flex-column min-vh-100">
    <div class="d-flex flex-grow-1">
        @if (!isLandingPage) {
            <div class="nav-bar-wrapper position-sticky">
                <ds-navigation-bar
                    #navBar
                    [items]="navigationItems()"
                    [isExpanded]="true"
                ></ds-navigation-bar>
            </div>
        }
        <main class="container-fluid py-6x flex-grow-1">
            <div class="app-scale-wrapper">
                <router-outlet></router-outlet>
            </div>
        </main>
    </div>
</div>

@if (!isLandingPage) {
    <footer class="app-footer border-top">
        <small>&copy; BMW Group 2025</small>
    </footer>
}
